export default {
	productIds: [
		'com.jdsoftwarellc.hearts.removeads',
		'com.jdsoftwarellc.hearts.fullversion',
	],
};
